<template>
  <div :inert="showStepModal || modalType" aria-hidden="showStepModal || modalType">
    <div class="flex justify-end items-center gap-4 mb-4 flex-wrap">
      <div class="flex flex-wrap gap-3 px-4 justify-end items-center">
        <SearchInput @search-select="onDealerSelected" @clear="onClearSearch" />

          <button @click="createModal"
          class="bg-primary-button hover:bg-primary-button-hover text-white ml-3 px-4 py-2 rounded transition-all duration-200 text-sm">
          + Yeni Sipariş Ekle
        </button>
      </div>
    </div>

    <div
      class="overflow-hidden rounded-md border border-light-border dark:border-dark-border bg-primary-bg text-primary-text dark:text-gray-100 dark:bg-primary-dark-bg  pb-3 shadow-md">
      <div class="w-full overflow-x-auto">
        <table class="min-w-full text-left text-sm text-secondary-text dark:text-gray-300">
          <thead class=" bg-gray-100 dark:bg-gray-800 font-medium">
            <tr>
              <th class="p-4"></th>
              <th class="p-3">Şirket Adı</th>
              <th class="p-3">Tarih</th>
              <th class="p-3">Sipariş No</th>
              <th class="p-3">Yük Adı</th>
              <th class="p-3">Yük Cinsi</th>
              <th class="p-3">Miktar</th>
              <th class="p-3">Kalan Miktar</th>
              <th class="p-3">Onay Bekleyen</th>
              <th class="p-3">Yükleme Miktarı</th>
              <th class="p-3">Yükleme Yeri</th>
              <th class="p-3">Sevk Yeri</th>
              <th class="p-3">İşlemler</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="order in orders" :key="order.id"
              class="border-b transition hover:light-hover dark:hover:dark-hover">
              <th class="p-4">
                <input type="checkbox" class="w-4 h-4 " :value="order.id"
                  @change="toggleOrderSelection(order.id, $event)" :checked="selectedOrders.some(s => s.id === order.id)">
              </th>
              <td class="p-3 font-medium text-primary-text dark:text-gray-100">{{ order.dealerName
              }}
              </td>
              <td class="p-3">
                {{ new Date(order.date).toLocaleString('tr-TR', {
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit',
                  timeZone: 'Europe/Istanbul'
                }) }}
              </td>
              <td class="p-3">{{ order.orderNumber }}</td>
              <td class="p-3"> {{order.loadType.map(c => c.category_name).join(', ')}}</td>
              <td class="p-3">
                {{order.loadProducts.map(u => u.urun_name).join(', ')}}
              </td>
              <td class="p-3">{{ formatTonnage(order.totalTonnage)  }}</td>
              <td class="p-3">{{  formatTonnage(order.remainingTonnage)}}</td>
              <td class="p-3" :class="order.pendingApproval > 0 ? 'text-yellow-600 font-bold' : 'text-green-600'">
                {{ formatTonnage(order.pendingApproval) }}
              </td>
              <td class="p-3">
                <input type="number" 
                       :value="getSelectedOrderValue(order.id, 'loadingTonnage')"
                       @input="updateLoadingTonnage(order.id, $event.target.value)"
                       class="w-full border rounded px-2 py-1 text-sm bg-primary-bg dark:bg-gray-800" />
              </td>
              <td class="p-3">
                <input type="text" 
                       :value="getSelectedOrderValue(order.id, 'loadingLocation')"
                       @input="updateLoadingLocation(order.id, $event.target.value)"
                       class="w-full border rounded px-2 py-1 text-sm bg-primary-bg dark:bg-gray-800" />
              </td>
              <td class="p-3">
                <input type="text" 
                       :value="getSelectedOrderValue(order.id, 'deliveryLocation')"
                       @input="updateDeliveryLocation(order.id, $event.target.value)"
                       class="w-full border rounded px-2 py-1 text-sm bg-primary-bg dark:bg-gray-800" />
              </td>
              <td class="p-3 space-x-2 text-center">
                <button @click="editModal(order)" class="relative group inline-block">
                  <PencilSquareIcon class="w-5 h-5 text-gray-500 hover:text-secondary-text" />
                  <span
                    class="absolute -top-8 left-1/2 -translate-x-1/2 scale-0 group-hover:scale-100 transition bg-black text-white text-xs px-2 py-1 rounded">
                    Düzenle
                  </span>
                </button>
               <button @click="deleteModal(order)" class="relative group">
                <svg class="w-5 h-5 text-red-500 hover:text-red-600" fill="none" stroke="currentColor"
                  viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
                <span
                  class="absolute -top-8 left-1/2 -translate-x-1/2 scale-0 group-hover:scale-100 transition bg-black text-white text-xs px-2 py-1 rounded">
                  Sil
                </span>
              </button> 
              </td>
            </tr>
            <tr v-if="!isLoading && orders.length === 0">
              <td colspan="13" class="py-10 text-center text-gray-400">
                <div class="flex justify-center items-center gap-2">
                  <span class="text-gray-500 dark:text-gray-400">Kayıt bulunamadı.</span>
                </div>
              </td>
            </tr>
            <tr v-if="isLoading">
              <td colspan="13" class="py-10 text-center text-gray-400">
                <div class="flex justify-center items-center gap-2">
                  <ArrowPathIcon class="w-5 h-5 animate-spin" />
                  Yükleniyor...
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <AppPagination 
        :currentPage="currentPage" 
        :totalPages="totalPages" 
        :pageSize="pageSize"
        :totalItems="totalOrdersCount"
        @prev-page="currentPage--"
        @next-page="currentPage++" 
        @go-to-page="page => currentPage = page"
        @update:pageSize="handlePageSizeChange"
      />

    </div>

    <div v-if="selectedOrders.length > 0" class="flex justify-end mt-4 px-4">
      <button @click="handleStepContinue"
        class="bg-primary-button hover:bg-primary-button-hover text-white text-sm px-6 py-2 rounded transition-all duration-200">
        Devam Et
      </button>
    </div>
  </div>

  <div v-if="showStepModal" @click.self="showStepModal = false"
    class="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
    <div
      class="bg-primary-bg dark:bg-primary-dark-bg p-6 sm:p-10 rounded-lg border border-light-border dark:border-dark-border overflow-y-auto custom-scroll relative max-h-[90vh]">
      <button @click="showStepModal = false"
        class="absolute top-2 right-2 text-gray-500 hover:text-black text-lg font-bold">
        <XMarkIcon class="w-6 h-6" />

      </button>
      <div class="mb-8">
        <h3 class="text-xl font-semibold mb-4 border-b pb-2 border-gray-200 dark:border-gray-700">Şoför Bilgileri</h3>
        <DriverForm :form="driverForm" :drivers="drivers" @update:form="form => driverForm = form"
          @reset="resetDriverForm" @create="createDriver" @search="fetchDrivers" @search-tc="fetchDriversByTC" />

      </div>
      <div>
        <h3 class="text-xl font-semibold mb-4 border-b pb-2 border-gray-200 dark:border-gray-700">Araç Bilgileri</h3>
        <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <div>
            <label>Plaka</label>
            <input v-model="vehicle.plate"
              class="w-full border rounded px-4 py-2 bg-primary-bg dark:bg-primary-dark-bg dark:border-dark-border focus:outline-none focus:ring focus:ring-indigo-300" />
          </div>
          <div>
            <label>Dorse Plaka</label>
            <input v-model="vehicle.trailer"
              class="w-full border rounded px-4 py-2 bg-primary-bg dark:bg-primary-dark-bg dark:border-dark-border focus:outline-none focus:ring focus:ring-indigo-300" />
          </div>
          <div>
            <label>Komisyon</label>
            <input type="number" v-model.number="vehicle.commission" step="0.01"
              class="w-full border rounded px-4 py-2 bg-primary-bg dark:bg-primary-dark-bg dark:border-dark-border focus:outline-none focus:ring focus:ring-indigo-300" />
          </div>
          <div>
            <label>Komisyon Ödeme Şekli</label>
            <select v-model="vehicle.commissionPaymentType"
              class="w-full border rounded px-4 py-2 bg-primary-bg dark:bg-primary-dark-bg dark:border-dark-border focus:outline-none focus:ring focus:ring-indigo-300">
              <option disabled value="">Seçiniz</option>
              <option value="cash">Nakit</option>
              <option value="credit_cart">Kredi Kartı</option>
              <option value="partial">Parçalı</option>
              <option value="loan">Veresiye</option>
            </select>
          </div>
          <div v-if="vehicle.commissionPaymentType === 'partial'" class="sm:col-span-3 grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div>
              <label>Nakit</label>
              <input type="number" v-model.number="vehicle.commissionCash" step="0.01" min="0"
                @input="onCashChanged"
                class="w-full border rounded px-4 py-2 bg-primary-bg dark:bg-primary-dark-bg dark:border-dark-border focus:outline-none focus:ring focus:ring-indigo-300" />
            </div>
            <div>
              <label>Kart</label>
              <input type="number" v-model.number="vehicle.commissionCard" step="0.01" min="0"
                @input="onCardChanged"
                class="w-full border rounded px-4 py-2 bg-primary-bg dark:bg-primary-dark-bg dark:border-dark-border focus:outline-none focus:ring focus:ring-indigo-300" />
            </div>
            <div class="flex items-end">
              <div class="text-sm text-secondary-text">Toplam: {{ Number(vehicle.commissionCash || 0) + Number(vehicle.commissionCard || 0) }} / {{ Number(vehicle.commission || 0) }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-12">
        <h3 class="text-xl font-semibold mb-4 border-b pb-2 border-gray-200 dark:border-gray-700">
          Teslimat Tipi Seçimi
        </h3>

        <div>
          <label class="inline-flex items-center">
            <input type="radio" value="fot" v-model="deliveryMethod" class="form-radio h-5 w-5 text-primary-button">
            <span class="ml-2">FOT</span>
          </label>
          <label class="inline-flex items-center ml-4">
            <input type="radio" value="cif" v-model="deliveryMethod" class="form-radio h-5 w-5 text-primary-button">
            <span class="ml-2">CIF</span>
          </label>
        </div>
      </div>
      <div class="flex justify-end mt-6">
        <button @click="handlePreview"
          class="bg-primary-button hover:bg-primary-button-hover text-white px-6 py-2 rounded transition-all duration-200 flex items-center gap-2">
          <!-- <PrinterIcon class="w-5 h-5" /> -->
          Önizleme Yap
        </button>
      </div>
    </div>
  </div>


  <OrderModal v-if="modalType === 'create' || modalType === 'edit'" :mode="modalMode" :order="selectedOrder"
    :dealerId="$route.params.dealerId" @submit="fetchOrders" @close="closeModal" @click.self="closeModal"
    :dealers="dealers" />
  
  <DeleteModal v-if="modalType === 'delete'" :item="selectedOrder"
    message="Bu gönderimi silmek istediğinizden emin misiniz?" @close="closeModal" @confirm-delete="handleDelete"
    @click.self="closeModal" /> 
  <PrintPreviewModal v-if="modalType === 'preview'" :selectedOrders="selectedOrderData" :driver="driverForm"
    :vehicle="vehicle" @close="closeModal" @cancel="resetPreviewState" @confirm-preview="confirmPreview"
    mode="invoice" />

</template>

<script>
import { getApi, postApi, putApi, deleteApi } from "@/services/api";
import OrderModal from '@/components/Modals/OrderModal.vue';
import PrintPreviewModal from '@/components/Modals/PrintPreviewModal.vue';
 import DeleteModal from '@/components/Modals/DeleteModal.vue';
import { PencilSquareIcon, ArrowPathIcon, XMarkIcon } from '@heroicons/vue/24/outline';
import SearchInput from '@/components/SearchInput.vue'
import DriverForm from '@/components/Forms/DriverForm.vue';

export default {
  name: "AllOrders",
  components: {
    SearchInput,
    OrderModal,
     DeleteModal,
    PrintPreviewModal,
    PencilSquareIcon,
    ArrowPathIcon,
    DriverForm,
    XMarkIcon,
    // PrinterIcon
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 50,
      totalOrdersCount: 0,
      modalMode: 'create',
      activeTab: 'preload',
      modalType: null,
      orders: [],
      drivers: [],
      selectedOrders: [], 
      selectedOrderData: [],
      selectedDealerId: null,
      driverForm: {
        driver_id: null,
        driver_name: '',
        driver_tcno: '',
        driver_dt: '',
        driver_telno: '',
        driver_licenceno: '',
        driver_status: '',
        driver_province: ' '
      },
      vehicle: {
        plate: '',
        trailer: '',
        commission: 0,
        commissionPaymentType: 'cash',
        commissionCash: 0,
        commissionCard: 0
      },
      isLoading: false,
      showStepModal: false,
      deliveryMethod: 'fot',
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalOrdersCount / this.pageSize);
    },
    // isFertilizerProduct() {
    //   const selected = this.orders.filter(order => this.selectedOrders.includes(order.id));
    //   return selected.some(order => 
    //     order.loadType?.some(type => 
    //       type.category_name === 'Gübre'
    //     )
    //   );
    // },
  },
  methods: {
    onCashChanged() {
      if (this.vehicle.commissionPaymentType !== 'partial') return;
      const total = Number(this.vehicle.commission || 0);
      let cash = Number(this.vehicle.commissionCash || 0);
      if (isNaN(cash) || cash < 0) cash = 0;
      if (cash > total) cash = total;
      this.vehicle.commissionCash = cash;
      const card = total - cash;
      this.vehicle.commissionCard = Number(card.toFixed(2));
    },
    onCardChanged() {
      if (this.vehicle.commissionPaymentType !== 'partial') return;
      const total = Number(this.vehicle.commission || 0);
      let card = Number(this.vehicle.commissionCard || 0);
      if (isNaN(card) || card < 0) card = 0;
      if (card > total) card = total;
      this.vehicle.commissionCard = card;
      const cash = total - card;
      this.vehicle.commissionCash = Number(cash.toFixed(2));
    },
    async generateBillId(deliveryMethod) {
      try {
        console.log(`Generating bill number for method: ${deliveryMethod}`);
        const response = await getApi(`/deliveries/generate-bill-number/${deliveryMethod}`);
        console.log(`API response:`, response);
        return response.bill_id;
      } catch (error) {
        console.error('Error generating bill number:', error);
        console.log('Falling back to UUID method');
        // Fallback to old method if API fails
        const prefix = deliveryMethod.toLowerCase() === 'cif' ? 'CIF' : 'FOT';
        const uuid = crypto.randomUUID().replace(/-/g, '').slice(0, 8).toUpperCase();
        return `${prefix}-${uuid}`;
      }
    },

    async generateGroupBillId(deliveryMethod) {
      try {
        console.log(`Generating group bill number for method: ${deliveryMethod}`);
        const response = await getApi(`/deliveries/generate-bill-number/${deliveryMethod}`);
        console.log(`Group API response:`, response);
        return response.bill_id;
      } catch (error) {
        console.error('Error generating group bill number:', error);
        console.log('Falling back to UUID method for group');
        // Fallback to old method if API fails
        const prefix = deliveryMethod.toLowerCase() === 'cif' ? 'CIF' : 'FOT';
        const uuid = crypto.randomUUID().replace(/-/g, '').slice(0, 8).toUpperCase();
        return `${prefix}-${uuid}`;
      }
    },

    createModal() {
      this.modalType = 'create';
      this.modalMode = 'create';
      this.selectedOrder = {};
    },
    editModal(order) {
      this.modalType = 'edit';
      this.modalMode = 'edit';
      this.selectedOrder = order;
    },
     deleteModal(order) {
       this.modalType = 'delete';
       this.selectedOrder = order;
     },
    openPreviewModal() {
      this.modalType = 'preview';
    },
    closeModal() {
  this.modalType = null;
  this.selectedOrder = null;
  
  this.resetDriverForm();
  this.selectedOrderData = [];
  
  this.orders = this.orders.map(order => ({
    ...order,
    loadingTonnage: "",
    loadingLocation: "",
    deliveryLocation: order.dealer?.shipment_address || ""
  }));
  
  this.showStepModal = false;
},
    onClearSearch() {
      this.selectedDealerId = null;
      this.currentPage = 1;
      
      this.clearAllSelections();
      
      this.loadOrders();
    },

    //     formatNumber(value) {
    //   if (value === null || value === undefined || value === '') return '';
    //   return Number(value).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    // },

formatPrice (value) {
  if (value === null || value === undefined) return '0,00';
  const parts = parseFloat(value).toFixed(2).split('.');
  const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  const decimalPart = parts[1];
  return `${integerPart},${decimalPart}`;
},

 formatTonnage (value) {
  if (value === null || value === undefined) return '0';
  const integerPart = Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return integerPart;
},


  loadSelectedOrders() {
    try {
      const saved = localStorage.getItem('selectedOrders');
      if (saved) {
        this.selectedOrders = JSON.parse(saved);
      }
    } catch (error) {
      this.selectedOrders = [];
    }
  },

  saveSelectedOrders() {
    try {
      localStorage.setItem('selectedOrders', JSON.stringify(this.selectedOrders));
    } catch (error) {
      console.error('Error saving selected orders:', error);
    }
  },

  toggleOrderSelection(orderId, event) {
    if (event.target.checked) {
      const order = this.orders.find(o => o.id === orderId);
      if (order) {
        if (this.selectedOrders.length > 0) {
          const firstSelectedOrder = this.orders.find(o => o.id === this.selectedOrders[0].id);
          if (firstSelectedOrder && firstSelectedOrder.dealer_id !== order.dealer_id) {
            this.clearAllSelections();
          }
        }
        
        const existingIndex = this.selectedOrders.findIndex(s => s.id === orderId);
        if (existingIndex === -1) {
          this.selectedOrders.push({
            id: orderId,
            loadingTonnage: "",
            loadingLocation: "Samsun",
            deliveryLocation: order.dealer?.shipment_address || ""
          });
        }
      }
    } else {
      this.selectedOrders = this.selectedOrders.filter(s => s.id !== orderId);
    }
    this.saveSelectedOrders();
  },

  updateLoadingTonnage(orderId, value) {
    let selectedOrder = this.selectedOrders.find(s => s.id === orderId);
    if (!selectedOrder) {
      const baseOrder = this.orders.find(o => o.id === orderId) || {};
      if (this.selectedOrders.length > 0) {
        const firstSelectedOrder = this.orders.find(o => o.id === this.selectedOrders[0].id);
        if (firstSelectedOrder && firstSelectedOrder.dealer_id !== baseOrder.dealer_id) {
          this.clearAllSelections();
        }
      }
      selectedOrder = {
        id: orderId,
        loadingTonnage: "",
        loadingLocation: "Samsun",
        deliveryLocation: baseOrder.dealer?.shipment_address || ""
      };
      this.selectedOrders.push(selectedOrder);
    }
    selectedOrder.loadingTonnage = value;
    this.saveSelectedOrders();
  },

  updateLoadingLocation(orderId, value) {
    let selectedOrder = this.selectedOrders.find(s => s.id === orderId);
    if (!selectedOrder) {
      const baseOrder = this.orders.find(o => o.id === orderId) || {};
      if (this.selectedOrders.length > 0) {
        const firstSelectedOrder = this.orders.find(o => o.id === this.selectedOrders[0].id);
        if (firstSelectedOrder && firstSelectedOrder.dealer_id !== baseOrder.dealer_id) {
          this.clearAllSelections();
        }
      }
      selectedOrder = {
        id: orderId,
        loadingTonnage: "",
        loadingLocation: "Samsun",
        deliveryLocation: baseOrder.dealer?.shipment_address || ""
      };
      this.selectedOrders.push(selectedOrder);
    }
    selectedOrder.loadingLocation = value;
    this.saveSelectedOrders();
  },

  updateDeliveryLocation(orderId, value) {
    let selectedOrder = this.selectedOrders.find(s => s.id === orderId);
    if (!selectedOrder) {
      const baseOrder = this.orders.find(o => o.id === orderId) || {};
      if (this.selectedOrders.length > 0) {
        const firstSelectedOrder = this.orders.find(o => o.id === this.selectedOrders[0].id);
        if (firstSelectedOrder && firstSelectedOrder.dealer_id !== baseOrder.dealer_id) {
          this.clearAllSelections();
        }
      }
      selectedOrder = {
        id: orderId,
        loadingTonnage: "",
        loadingLocation: "Samsun",
        deliveryLocation: baseOrder.dealer?.shipment_address || ""
      };
      this.selectedOrders.push(selectedOrder);
    }
    selectedOrder.deliveryLocation = value;
    this.saveSelectedOrders();
  },

  getSelectedOrderValue(orderId, field) {
    const selectedOrder = this.selectedOrders.find(s => s.id === orderId);
    if (selectedOrder) {
      const value = selectedOrder[field] || "";
      return value;
    }
    return "";
  },

      clearAllSelections() {
      this.selectedOrders = [];
      this.saveSelectedOrders();
    },
    
    handlePageSizeChange(newPageSize) {
      this.pageSize = newPageSize;
      this.currentPage = 1;
      this.fetchOrders();
    },


async getSelectedOrdersData() {
  if (this.selectedOrders.length === 0) return [];
  const selectedOrdersData = [];
  for (const order of this.selectedOrders) {
    const response = this.orders.find(o => o.id === order.id);
    if (response) {
      selectedOrdersData.push({
        ...response,
        loadingTonnage: order.loadingTonnage,
        loadingLocation: order.loadingLocation,
        deliveryLocation: order.deliveryLocation,
        deliveryMethod: this.deliveryMethod || 'fot'
      });
    }
  }
  return selectedOrdersData;
},


    async handleStepContinue() {
    const selected = await this.getSelectedOrdersData();

    if (selected.length === 0) {
      this.$toast.error("Seçili sipariş bulunamadı!");
      return;
    }

    const isAnyOverloaded = selected.some(order =>
      Number(order.loadingTonnage) > Number(order.remainingTonnage)
    );

    const isAnyEmptyTonnage = selected.some(order =>
    !order.loadingTonnage || Number(order.loadingTonnage) <= 0
  );

     if (isAnyEmptyTonnage) {
    this.$toast.error("Her sipariş için yükleme miktarı girilmelidir!");
    return;
  }

    if (isAnyOverloaded) {
      this.$toast.error("Yükleme miktarı, kalan miktardan fazla olamaz!");
      return;
    }

    this.showStepModal = true;
    
  },

    async getAllDeliveriesMap() {
      const take = this.pageSize;
      const skip = (this.currentPage - 1) * this.pageSize;

      let allApproved = [];
      let allUnapproved = [];

      try {
        const approvedRes = await getApi(`/deliveries/approved/${take}/${skip}`);
        allApproved = approvedRes?.deliveries || [];

        const unapprovedRes = await getApi(`/deliveries/unapproved/${take}/${skip}`);
        allUnapproved = unapprovedRes?.deliveries || [];

        const approvedMap = {};
        const pendingMap = {};

        allApproved.forEach(d => {
          const orderId = d.order_id;
          const tonnage = parseFloat(d.delivery_tonnage || 0);
          if (!orderId) return;
          approvedMap[orderId] = (approvedMap[orderId] || 0) + tonnage;
        });

        allUnapproved.forEach(d => {
          const orderId = d.order_id;
          const tonnage = parseFloat(d.delivery_tonnage || 0);
          if (!orderId) return;
          pendingMap[orderId] = (pendingMap[orderId] || 0) + tonnage;
        });

        return { approvedMap, pendingMap };
      } catch (error) {
        return { approvedMap: {}, pendingMap: {} };
      }
    },


async loadOrders({ dealerId = null } = {}) {
  this.isLoading = true;
  try {
    const take = this.pageSize;
    const skip = (this.currentPage - 1) * this.pageSize;

    let response;
    if (dealerId) {
      response = await getApi(`/orders/by_dealers/${dealerId}/${take}/${skip}`);
    } else {
      response = await getApi(`/orders/${take}/${skip}`);
    }

    const ordersFromApi = response.orders || [];

    this.orders = ordersFromApi.map(order => ({
      id: order.order_id,
      dealer_id: order.dealer_id,
      dealer: order.dealer || {},
      dealerName: order.dealer?.dealer_name || 'Bayi Bilgisi Yok',
      date: new Date(order.order_time),
      orderNumber: order.order_number || "-",
      loadProducts: order.ordered_products?.map(p => ({
        urun_name: p.product?.name || 'Ürün Bilgisi Yok',
        id: p.product?.id
      })) || [],
      loadType: order.ordered_products?.map(p => ({
        category_name: p.product?.category?.category_name || 'Kategori Bilgisi Yok'
      })) || [],
      totalTonnage: order.order_tonnage,
      deliveredTonnage: order.delivered_tonnage || 0,
      pendingApproval: order.pending_tonnage || 0,
      remainingTonnage: order.remaining_tonnage || (order.order_tonnage - ((order.delivered_tonnage || 0) + (order.pending_tonnage || 0))),
      loadingTonnage: "",
      loadingLocation: "Samsun",
      deliveryLocation: order.dealer?.shipment_address || "",
      deliveryMethod: 'fot'
    })).filter(order => order.remainingTonnage > 0 || order.deliveredTonnage > 0 || order.pendingApproval > 0);

    this.totalOrdersCount = response.total_result || ordersFromApi.length;

  } catch (error) {
    this.orders = [];
    this.totalOrdersCount = 0;
  } finally {
    this.isLoading = false;
  }
},

    async onDealerSelected(dealer) {
      this.currentPage = 1;
      this.selectedDealerId = dealer.dealer_id;
      
      this.clearAllSelections();
      
      await this.loadOrders({ dealerId: this.selectedDealerId });
    },

    async fetchOrders() {
      await this.loadOrders({ dealerId: this.selectedDealerId });
    },

    async handleDelete(order) {
  try {
    await deleteApi(`/orders/id/${order.id}`);
    this.$toast.success("Sipariş başarıyla silindi!");
    this.fetchOrders();
  } catch (error) {
    const detail = error.response?.data?.detail || "Silme işlemi sırasında hata oluştu!";
    this.$toast.error(detail);
  } finally {
    this.modalType = null;
    this.selectedOrder = null;
  }
},

    getEmptyDriverForm() {
      return {
        driver_id: null,
        driver_name: '',
        driver_tcno: '',
        driver_dt: '',
        driver_telno: '',
        driver_licenceno: '',
        driver_status: '',
        driver_province: ''
      };
    },

    resetDriverForm() {
      this.driverForm = this.getEmptyDriverForm();
    },

    getEmptyVehicle() {
      return {
        plate: '',
        trailer: '',
        commission: 0,
        commissionPaymentType: 'cash',
        commissionCash: 0,
        commissionCard: 0
      };
    },

    resetVehicle() {
      this.vehicle = this.getEmptyVehicle();
    },

    async fetchDrivers(query = '') {
      try {
        if (query.length < 1) {
          this.drivers = [];
          return;
        }

        const response = await getApi(`/drivers/query/license/${query}`);

        this.drivers = response
          .filter(driver => driver.driver_status !== 0)
          .map(driver => ({
            ...driver,
            id: driver.driver_id
          }));
      } catch (error) {
        // this.$toast.error("Sürücüler alınırken hata oluştu!");
      }
    },

    async fetchDriversByTC(query = '') {
      try {
        if (query.length < 1) {
          this.drivers = [];
          return;
        }

        const response = await getApi(`/drivers/query/tc/${query}`);

        this.drivers = response
          .filter(driver => driver.driver_status !== 0)
          .map(driver => ({
            ...driver,
            id: driver.driver_id
          }));
      } catch (error) {
        // this.$toast.error("Sürücüler alınırken hata oluştu!");
      }
    },

    async createDriver() {
      try {
        if (this.driverForm.driver_tcno.length >= 1 || this.driverForm.driver_licenceno.length >= 1) {
          await this.fetchDrivers(this.driverForm.driver_tcno || this.driverForm.driver_licenceno);
        }

        const existingDriver = this.drivers.find(driver =>
          driver.driver_licenceno === this.driverForm.driver_licenceno &&
          driver.driver_province === this.driverForm.driver_province
        );

        const existingDriverTC = this.drivers.find(driver =>
          driver.driver_tcno === this.driverForm.driver_tcno
        );

        if (existingDriver) {
          this.$toast.error('Bu ehliyet numarası ve şehir kombinasyonu zaten mevcut!');
          return;
        }

        if (existingDriverTC) {
          this.$toast.error('Bu TC zaten mevcut!');
          return;
        }

        const payload = {
          ...this.driverForm,
          driver_dt: this.driverForm.driver_dt || "2025-01-01",
          driver_status: this.driverForm.driver_status === '' ? 1 : parseInt(this.driverForm.driver_status)
        };
        delete payload.driver_id;

        await postApi('/drivers/', payload);
        this.$toast.success('Yeni şoför başarıyla eklendi!');
        await this.fetchDrivers();
        this.resetDriverForm();

      } catch (error) {
        this.$toast.error('Şoför eklenirken bir hata oluştu!');
      }
    },

    async handlePreview() {
      const licenseNumber = this.driverForm?.driver_licenceno?.trim() || '';
      const fullName = this.driverForm?.driver_name?.trim() || '';
      const identityNumber = this.driverForm?.driver_tcno?.trim() || '';
      const phone = this.driverForm?.driver_telno?.trim() || '';
      const city = this.driverForm?.driver_province?.trim() || '';
      const plate = this.vehicle?.plate?.trim() || '';
      const trailerPlate = this.vehicle?.trailer?.trim() || '';
      const commission = this.vehicle?.commission;
      const paymentType = this.vehicle?.commissionPaymentType;


      const isDriverValid = !!fullName && !!identityNumber && !!licenseNumber && !!phone && !!city;
      const isVehicleValid = !!plate && !!trailerPlate;
      const isCommissionValid = commission !== '' && commission !== null && !isNaN(commission);
      const isPaymentTypeValid = !!paymentType;
      let isPartialValid = true;
      if (paymentType === 'partial') {
        const cash = Number(this.vehicle.commissionCash || 0);
        const card = Number(this.vehicle.commissionCard || 0);
        const total = Number(commission || 0);
        isPartialValid = cash >= 0 && card >= 0 && Math.abs((cash + card) - total) < 0.005;
      }

      if (!isDriverValid) {
        this.$toast.error("Lütfen şoför bilgilerini doldurun.");
        return;
      }

      if (!isVehicleValid) {
        this.$toast.error("Lütfen araç plakası ve dorse plakası bilgilerini doldurun.");
        return;
      }

      if (!isCommissionValid || !isPaymentTypeValid || !isPartialValid) {
        this.$toast.error("Lütfen komisyon, ödeme şekli ve Parçalı ise Nakit/Kart toplamını doğrulayın.");
        return;
      }

      const selected = await this.getSelectedOrdersData();

      console.log(`About to generate group bill_id for method: ${this.deliveryMethod}`);
      const groupBillId = await this.generateGroupBillId(this.deliveryMethod);
      console.log(`Generated group bill_id: ${groupBillId} for ${selected.length} orders`);
      
      const updatedSelectedData = [];
      for (const order of selected) {
        console.log(`Assigning bill_id: ${groupBillId} to order: ${order.id}`);
        
        updatedSelectedData.push({
          ...order,
          bill_id: groupBillId, 
          deliveryMethod: this.deliveryMethod || 'fot',
          companyName: order.dealerName || 'Şirket Bilgisi Yok',
          companyPhone: order.dealer?.dealer_tel || '',
          companyFax: order.dealer?.dealer_fax || '',
          vehiclePlate: plate,
          trailerPlate: trailerPlate,
          driverName: fullName,
          driverId: identityNumber,
          driverPhone: phone,
          driverLicense: licenseNumber,
          driverCity: city,
          commission: commission,
          commissionPaymentType: paymentType,
          commissionCash: this.vehicle.commissionPaymentType === 'partial' ? Number(this.vehicle.commissionCash || 0) : null,
          commissionCard: this.vehicle.commissionPaymentType === 'partial' ? Number(this.vehicle.commissionCard || 0) : null
        });
        
      }

      this.selectedOrderData = updatedSelectedData;

      this.openPreviewModal();
    },


    resetPreviewState() {
      this.modalType = null;
      this.resetVehicle();
      this.deliveryMethod = 'fot';
    },

    async confirmPreview() {
  
      const commissionAmount = Number(this.vehicle.commission);
      const driverId = Number(this.driverForm.driver_id);
      const paymentType = this.vehicle.commissionPaymentType;
      const cashAmount = this.vehicle.commissionPaymentType === 'partial' ? Number(this.vehicle.commissionCash || 0) : null;
      const cardAmount = this.vehicle.commissionPaymentType === 'partial' ? Number(this.vehicle.commissionCard || 0) : null;

      if (commissionAmount === null || isNaN(commissionAmount) || commissionAmount < 0 || !paymentType) {
        this.$toast.error('Lütfen geçerli bir komisyon ve ödeme şeklini belirtiniz!');
        return;
      }
      if (paymentType === 'partial') {
        if (cashAmount === null || cardAmount === null || cashAmount < 0 || cardAmount < 0 || Math.abs((cashAmount + cardAmount) - commissionAmount) >= 0.005) {
          this.$toast.error('Parçalı ödemede Nakit ve Kart toplamı komisyona eşit olmalıdır.');
          return;
        }
      }

      if (!driverId || isNaN(driverId)) {
        this.$toast.error('Geçerli bir şoför seçiniz!');
        return;
      }

      try {
        // 1) Create all deliveries with the same bill_id
        const createdDeliveries = [];
        for (const order of this.selectedOrderData) {
          const payload = {
            order_id: order.id,
            dealer_id: order.dealer_id,
            product_id: order.loadProducts?.[0]?.id || 0,
            delivery_tonnage: Number(order.loadingTonnage),
            drivers_id: driverId,
            drivers_tel: this.driverForm.driver_telno,
            delivery_plate: order.vehiclePlate,
            delivery_trailer: order.trailerPlate,
            delivery_shipment_address: order.deliveryLocation,
            delivery_time: new Date().toISOString(),
            waybill: "",
            bill_id: order.bill_id,
            is_approved: 0,
            delivery_method: order.deliveryMethod
          };

          const deliveryRes = await postApi('/deliveries/', payload);
          if (deliveryRes && deliveryRes.delivery_id) {
            createdDeliveries.push(deliveryRes.delivery_id);
          }
        }

        // 2) Create ONE commission tied to the first created delivery
        if (createdDeliveries.length > 0) {
          const firstDeliveryId = createdDeliveries[0];

          const commissionPayload = {
            driver_id: driverId,
            commission_amount: commissionAmount,
            delivery_id: firstDeliveryId,
            payment_type: paymentType,
            cash_amount: paymentType === 'partial' ? cashAmount : (paymentType === 'cash' ? commissionAmount : 0),
            card_amount: paymentType === 'partial' ? cardAmount : (paymentType === 'credit_cart' ? commissionAmount : 0)
          };

          // Use nested deliveries commission endpoint for consistency
          // Backend no longer auto-creates commissions during delivery creation
          try {
            // Try create; if already exists, update
            await postApi(`/deliveries/${firstDeliveryId}/commission`, commissionPayload);
          } catch (e) {
            await putApi(`/deliveries/${firstDeliveryId}/commission`, commissionPayload);
          }
        }

        this.$toast.success('Yükleme fişi başarıyla oluşturuldu.');
        this.resetPreviewState();
        this.showStepModal = false;
        
        this.clearAllSelections();
        
        await this.fetchOrders();

      } catch (error) {
        this.$toast.error('Fiş oluşturulurken hata oluştu!');
      }
    }

  },

  watch: {
    'vehicle.commissionPaymentType'(val) {
      if (val === 'partial') {
        // Initialize split evenly by default
        const total = Number(this.vehicle.commission || 0);
        const half = Number((total / 2).toFixed(2));
        this.vehicle.commissionCash = half;
        this.vehicle.commissionCard = Number((total - half).toFixed(2));
      } else {
        // Normalize amounts for non-partial types
        const total = Number(this.vehicle.commission || 0);
        this.vehicle.commissionCash = val === 'cash' ? total : 0;
        this.vehicle.commissionCard = val === 'credit_cart' ? total : 0;
      }
    },
    'vehicle.commission'(total) {
      if (this.vehicle.commissionPaymentType === 'partial') {
        const cash = Number(this.vehicle.commissionCash || 0);
        // Keep cash within 0..total, recompute card
        let newCash = isNaN(cash) ? 0 : cash;
        if (newCash < 0) newCash = 0;
        if (newCash > Number(total || 0)) newCash = Number(total || 0);
        this.vehicle.commissionCash = newCash;
        this.vehicle.commissionCard = Number(((Number(total || 0)) - newCash).toFixed(2));
      } else {
        const t = Number(total || 0);
        this.vehicle.commissionCash = this.vehicle.commissionPaymentType === 'cash' ? t : 0;
        this.vehicle.commissionCard = this.vehicle.commissionPaymentType === 'credit_cart' ? t : 0;
      }
    },
    currentPage() {
      this.fetchOrders();
    },
    pageSize() {
      this.currentPage = 1;
      this.fetchOrders();
    },
    showStepModal(newVal) {
      if (!newVal) {
        this.resetVehicle();
        this.deliveryMethod = 'fot';
      }
    },
    // isFertilizerProduct(newValue) {
    //   if (newValue) {
    //     this.deliveryMethod = null;
    //   }
    // },
    // selectedOrders: {
    //   handler(newValue) {
    //     if (newValue && newValue.length > 0) {
    //       const selected = this.orders.filter(order => newValue.includes(order.id));
    //       const hasFertilizer = selected.some(order => 
    //         order.loadType?.some(type => 
    //           type.category_name === 'Gübre'
    //         )
    //       );
    //       if (hasFertilizer) {
    //         this.deliveryMethod = null;
    //       }
    //     }
    //   },
    //   deep: true
    // }
  },

  async mounted() {
    this.clearAllSelections();
    await this.fetchDrivers();
    await this.fetchOrders();
  }
};
</script>
